import { RELATIONSHIPS } from '../constants/relationships';

export const formatAddressLine = (personalDetails) => {
  const { address, suburb, state, postcode } = personalDetails || {};
  const localityLine = [suburb, state, postcode].filter(Boolean).join(' ');

  return [address, localityLine].filter(Boolean).join(', ');
};

export const formatRelationshipLabel = (relationship) => {
  if (!relationship) return '';

  const matchedRelationship = RELATIONSHIPS.find(
    ({ value }) => value === relationship
  );

  return matchedRelationship ? matchedRelationship.label : relationship;
};
